export default ({
  SECTION                                           : 'integrations',

  BUSINESS_INTEGRATION_SET_IMPORT_LOCUSPRIME_PATIENTS_TOKEN : 'BUSINESS_INTEGRATION_SET_IMPORT_LOCUSPRIME_PATIENTS_TOKEN',

  BUSINESS_INTEGRATION_IMPORT_LOCUSPRIME_PATIENTS_FETCH_REQUEST : 'BUSINESS_INTEGRATION_IMPORT_LOCUSPRIME_PATIENTS_FETCH_REQUEST',
  BUSINESS_INTEGRATION_IMPORT_LOCUSPRIME_PATIENTS_FETCH_SUCCESS : 'BUSINESS_INTEGRATION_IMPORT_LOCUSPRIME_PATIENTS_FETCH_SUCCESS',
  BUSINESS_INTEGRATION_IMPORT_LOCUSPRIME_PATIENTS_FETCH_ERROR   : 'BUSINESS_INTEGRATION_IMPORT_LOCUSPRIME_PATIENTS_FETCH_ERROR'
});